import { ViewerResponse, ResponseType } from './shared/model/docavea-viewer-interface';
import { TEST_MODE, loadPdfPayload, loadAndThumbPayload, latestRequest, viewerMode } from './main';
import { debug } from './debug';

let port1: MessagePort;
let viewerId = -1;

export function initChannelMessaging(port: MessagePort) {
    if (viewerMode !== 'viewerTab') {
        port1 = port;
        port1.start();
    }
}

export function setViewerId(id: number) {
    viewerId = id;
}

export function sendResponse(responseType: ResponseType, payload: any) {
    if (TEST_MODE || viewerMode === 'viewerTab') {
        return;
    }
    let docKey: string;
    if (loadPdfPayload !== undefined) {
        docKey = loadPdfPayload.docKey;
    } else if (loadAndThumbPayload !== undefined) {
        docKey = loadAndThumbPayload.docKey;
    } else {
        docKey = 'unknown';
    }
    const response: ViewerResponse = {
        responseType,
        latestRequest,
        viewerId,
        docKey,
        payload,
    };
    if (response.responseType !== ResponseType.PROGRESS && response.responseType !== ResponseType.MOUSE_MOVE) {
        debug('sendResponse ResponseType', ResponseType[response.responseType], 'payload', response.payload);
    }

    if (port1) {
        port1.postMessage(response);
    }
}
